import { render, staticRenderFns } from "./AdditionalBillingPricing.vue?vue&type=template&id=60f81478&scoped=true&"
import script from "./AdditionalBillingPricing.vue?vue&type=script&lang=js&"
export * from "./AdditionalBillingPricing.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalBillingPricing.vue?vue&type=style&index=0&id=60f81478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f81478",
  null
  
)

export default component.exports